import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo/icho_bg.png';
import _imports_1 from '@/assets/logo/contact1.jpg';
import _imports_2 from '@/assets/logo/contact2.png';
import _imports_3 from '@/assets/logo/beian.png';
const _withScopeId = n => (_pushScopeId("data-v-5f090bcc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "footer"
};
const _hoisted_2 = {
  class: "main-width d-flex jc-between content_box"
};
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"left\" data-v-5f090bcc><div class=\"img_box\" data-v-5f090bcc><img src=\"" + _imports_0 + "\" data-v-5f090bcc><div class=\"title_box\" data-v-5f090bcc><div class=\"img_box_title pb-2\" data-v-5f090bcc>WELL碳手印</div><div class=\"img_box_subtitle\" data-v-5f090bcc>以碳携手·造福于人</div></div></div></div>", 1);
const _hoisted_4 = {
  class: "middle"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title pb-20"
}, "快速访问", -1));
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"right\" data-v-5f090bcc><div class=\"title pb-20\" data-v-5f090bcc>联系我们</div><div class=\"d-flex text-center\" data-v-5f090bcc><div data-v-5f090bcc><img class=\"contact1\" src=\"" + _imports_1 + "\" width=\"200\" data-v-5f090bcc><div class=\"pr-20 pt-5\" data-v-5f090bcc>WELL碳手印<br data-v-5f090bcc>官方公众号</div></div><div data-v-5f090bcc><img src=\"" + _imports_2 + "\" width=\"200\" data-v-5f090bcc><div class=\"pt-5\" data-v-5f090bcc>WELL碳手印<br data-v-5f090bcc>活动组委会</div></div></div></div>", 1);
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"main-width b-b bottom_content d-flex ai-center jc-between\" data-v-5f090bcc><div class=\"copyright_box\" data-v-5f090bcc><span class=\"fs-xs\" data-v-5f090bcc>国际碳手印组织版权所有 | </span><a class=\"fs-xs\" href=\"https://beian.miit.gov.cn/\" data-v-5f090bcc>浙ICP备2024137349号-1</a></div><div data-v-5f090bcc><a class=\"d-flex ai-center\" target=\"_blank\" href=\"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33019202000649\" data-v-5f090bcc><img src=\"" + _imports_3 + "\" data-v-5f090bcc><span class=\"fs-xs pl-5\" data-v-5f090bcc>浙公网安备 33019202000649号</span></a></div></div>", 1);
import { useRouter } from 'vue-router';
export default {
  __name: 'Footer',
  setup(__props) {
    const router = useRouter();
    const toPage = url => {
      router.push({
        path: url
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", {
        class: "content",
        onClick: _cache[0] || (_cache[0] = $event => toPage('/carbon-friend'))
      }, "碳友团"), _createElementVNode("div", {
        class: "content",
        onClick: _cache[1] || (_cache[1] = $event => toPage('/member'))
      }, "会员计划"), _createElementVNode("div", {
        class: "content",
        onClick: _cache[2] || (_cache[2] = $event => toPage('/export'))
      }, "成为赋能官"), _createElementVNode("div", {
        class: "content",
        onClick: _cache[3] || (_cache[3] = $event => toPage('/about'))
      }, "关于我们")]), _hoisted_6]), _hoisted_7]);
    };
  }
};